




































































import CoSkeleton from '../../Atoms/co-skeleton/CoSkeleton.vue';
import CoText from '../../Atoms/co-text/CoText.vue';
import CoCard from '../co-card/CoCard.vue';
import CoDate from '../co-date/CoDate.vue';
import CoEditorContent from '../co-editor-content/CoEditorContent.vue';
import CoThumbnail from '../co-thumbnail/CoThumbnail.vue';
import CoContentPreview from '../../Organisms/co-content-preview/CoContentPreview.vue';

interface Message {
    ID: string;
    From: string;
    To: string;
    Text: string;
    Timestamp: number;
    Status: string;
    SpaceID: string;
    ThreadID: string;
}

interface Author {
    ID: string;
    ImageURL?: string;
    Slug?: string;
    Name?: string;
    Firstname?: string;
    Lastname?: string;
    HasLeft?: boolean;
}

export default {
    name: 'CoMessage',
    i18n: {
        messages: {
            en: {
                sent: 'Sent',
                delivered: 'Delivered',
                read: 'Read',
            },
            de: {
                sent: 'Gesendet',
                delivered: 'Zugestellt',
                read: 'Gelesen',
            },
        },
    },
    components: {
        CoText,
        CoCard,
        CoEditorContent,
        CoThumbnail,
        CoDate,
        CoSkeleton,
        CoContentPreview,
    },
    props: {
        message: {
            type: Object as () => Message,
            required: true,
        },
        isMine: {
            type: Boolean,
            default: false,
        },
        author: {
            type: Object as () => Author,
            default: () => ({}),
        },
        senderleft: {
            type: Boolean,
            default: false,
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        parsedMessage() {
            return this.extractSharedContent(this.message?.Text || '');
        },
        messageBodyContent() {
            return this.parsedMessage.bodyHtml;
        },
        sharedContentFetch() {
            return this.parsedMessage.fetch;
        },
    },
    methods: {
        extractSharedContent(html: string) {
            const fallback = {
                bodyHtml: html,
                fetch: null as { Slug: string } | null,
            };

            if (!html || typeof window === 'undefined' || typeof DOMParser === 'undefined') {
                return fallback;
            }

            try {
                const parser = new DOMParser();
                const doc = parser.parseFromString(`<div>${html}</div>`, 'text/html');
                const root = doc.body.firstElementChild as HTMLElement | null;
                if (!root) {
                    return fallback;
                }

                const blocks = Array.from(root.children);
                const firstBlock = blocks[0] as HTMLElement | undefined;
                if (!firstBlock) {
                    return fallback;
                }

                const anchors = Array.from(firstBlock.querySelectorAll('a'));
                const textContent = (firstBlock.textContent || '').trim();
                if (anchors.length !== 1 || !anchors[0].href || textContent !== (anchors[0].textContent || '').trim()) {
                    return fallback;
                }

                firstBlock.remove();
                const bodyHtml = root.innerHTML.trim();

                return {
                    bodyHtml,
                    fetch: {
                        Slug: anchors[0].href,
                    },
                };
            } catch (error) {
                return fallback;
            }
        },
    },
};
